import { createContext, useContext, useEffect, useState } from 'react';

import useProgressProvider from './ProgressProvider';
import useSessionProvider from './SessionProvider';
import { useTranslation } from 'react-i18next';

const SurveyContext = createContext<any>({});

export const SurveyProvider = ({ children }) => {
    const [question_queue, setQuestion_queue] = useState([]);
    const [question_done, setQuestion_done] = useState([]);
    const [remainingTime, setRemainingTime] = useState(0);
    const [timeFlag, setTimeflag] = useState(false);
    const [loading, setLoading] = useState(false);

    const [question_pending, setQuestion_pending] = useState([]);
    const { i18n } = useTranslation();
    const [convo, setConvo] = useState([]);
    const { user, survey, connection, setStatus } = useSessionProvider();
    const { setProgress, setTotal } = useProgressProvider();

    useEffect(() => {
        if (connection) {
            connection.on('onResponse', (payload) => {
                console.log('onResponse');
                const { queue, done, pending, progress, status, chat } = payload;
                setConvo([...chat]);
                setQuestion_queue([...queue]);
                setQuestion_done([...done]);
                setQuestion_pending([...pending]);
                setStatus(status);
                setProgress(progress);
                const { total } = GetProgress(done, queue);
                const time = GetRemainingTime(done, queue);
                setRemainingTime(time);
                setTotal(total);
                setLoading(false);
            });
        }
    }, [connection, setProgress, setTotal, setStatus, setRemainingTime]);

    const ApplyDataSourceLogic = (question, user) => {
        var dataSourceCondition = true;
        if (question.dataSource && question.datasourceColumn) {
            var datasourceValue = user[question.datasourceColumn?.toLowerCase()];
            if (datasourceValue) {
                var value = JSON.parse(datasourceValue.split("'").join('"'));
                if (value && Array.isArray(value) && value.length > 1) {
                    dataSourceCondition = true;
                } else {
                    dataSourceCondition = false;
                }
            } else {
                dataSourceCondition = false;
            }
        }

        return dataSourceCondition;
    };

    const ApplyPlaceholderLogic = (question, user) => {
        var placeholderLogics = question.logics.filter((x) => x.logicType === 'placeholder');
        if (placeholderLogics && placeholderLogics.length > 0) {
            let expression = '';
            for (let j = 0; j < placeholderLogics.length; j++) {
                let logic = placeholderLogics[j];
                if (j > 0) {
                    expression += logic.logicalOperator === 'Or' ? '||' : '&&';
                }
                let datasourceValue = user[logic.field.toLowerCase()];
                var cond = datasourceValue === logic.value;
                expression += cond;
            }
            return eval(expression);
        } else {
            return true;
        }
    };

    const InitSurvey = (SurveyQuestions, user) => {
        let queue = [];
        let pending = [];
        const questions = SurveyQuestions.sort((a, b) => a.order - b.order);
        for (var i = 0; i < questions.length; i++) {
            let question = questions[i];
            var dataSourceCondition = ApplyDataSourceLogic(question, user);
            if (
                question.logics &&
                question.logics.length > 0 &&
                question.logics.filter((x) => x.logicType === 'display')?.length === 0
            ) {
                let placeholderCondition = ApplyPlaceholderLogic(question, user);
                if (placeholderCondition && dataSourceCondition) {
                    queue.push(question);
                    continue;
                }
            } else if (dataSourceCondition && question.logics.length === 0) {
                queue.push(question);
                continue;
            }
            pending.push(question);
        }
        setQuestion_queue((prev) => {
            return [...queue];
        });
        setQuestion_pending((prev) => {
            return [...pending];
        });

        console.log({ queue, pending });

        return { queue, pending };
    };
    const uniqByKeepFirst = (a, key) => {
        let seen = new Set();
        return a.filter((item) => {
            let k = key(item);
            return seen.has(k) ? false : seen.add(k);
        });
    };

    const PopulateDoneQuestions = (serverQuestions, queue, pending, surveyQuestions) => {
        let done = [];
        if (serverQuestions && serverQuestions.length > 0) {
            serverQuestions = [...uniqByKeepFirst(serverQuestions, (it) => it.question_id)];
            serverQuestions.forEach((x) => {
                var question = surveyQuestions.find((ques) => ques.id === x.question_id);
                if (question) {
                    var inQueue = queue.find((queueQuestion) => queueQuestion.id === question.id);
                    if (inQueue) {
                        queue = queue.filter((queueQuestion) => queueQuestion.id !== question.id);
                    }
                    var inPending = pending.find((queueQuestion) => queueQuestion.id === question.id);
                    if (inPending) {
                        pending = pending.filter((queueQuestion) => queueQuestion.id !== question.id);
                    }
                    done.push(question);
                }
            });
        }
        return { done, queue, pending };
    };
    const GetQuestionOptions = (question, defaultLanguageCode, languageCode, user) => {
        let options = [];
        if (question.type !== 'Comment List') {
            if (question.dataSource === true && question.datasourceColumn) {
                let datasourceValue = user[question.datasourceColumn.toLowerCase()];
                if (datasourceValue) {
                    let value = JSON.parse(datasourceValue.split("'").join('"'));
                    if (value && Array.isArray(value)) {
                        options = [...value].map((x) => {
                            return {
                                label: x,
                                value: x
                            };
                        });
                    }
                }
            } else {
                options =
                    question.type === 'Rating'
                        ? [
                              ...question.rating[defaultLanguageCode].map((x) => {
                                  return {
                                      label: x,
                                      value: x
                                  };
                              })
                          ]
                        : question.type === 'Star Rating'
                        ? Array.from({ length: question?.numOfStars }, (_, i) => i + 1).map((x) => {
                              return {
                                  label: x.toString(),
                                  value: x.toString()
                              };
                          })
                        : [
                              ...question.options[languageCode].map((x) => {
                                  return {
                                      label: x.label,
                                      value: x.id
                                  };
                              })
                          ];
            }
        }
        return { options };
    };

    const ApplyDisplayLogic = (question, responses, surveyQuestions, defaultLanguageCode) => {
        let cond = '';
        question.logics
            .filter((x) => x.logicType === 'display')
            .forEach((logic, index) => {
                var clientMessage = responses.find(
                    (x) => x.question_id === logic.order // 3
                );
                if (index > 0) {
                    if (logic?.logicalOperator?.toLowerCase() === 'OR'.toLowerCase()) {
                        cond += '||';
                    } else {
                        cond += '&&';
                    }
                }

                if (index === 0) {
                }
                if (clientMessage) {
                    var response = `'${clientMessage?.text[0]}'`;
                    const question = surveyQuestions.find((x) => x.id === logic.order);

                    let value = logic.value; // 5
                    if (question) {
                        const { options } = GetQuestionOptions(question, defaultLanguageCode, i18n.language, user);
                        if (question.type === 'Checkbox List' || question.type === 'Radio List') {
                            value = logic.options
                                .filter((option) => logic.value.split(',').includes(option.value))
                                .map((x) => x.label);
                        } else {
                            // inserting 'N/A' in options to compare it later with selected answer
                            options.push({ label: 'N/A', value: 'N/A' });
                            value = options.find((x) => x.value === logic.value)?.label;
                        }
                    }
                    var logicExpression = ``;

                    if (question.type === 'Rating' || question.type === 'Star Rating') {
                        if (clientMessage?.text[0] !== 'N/A') {
                            logicExpression = `${
                                clientMessage?.text[0] +
                                (logic.operator === '='
                                    ? '=='
                                    : logic.operator) /* > < >= <= 'Option 1 = Option 1' '5 < 5'*/
                            }${parseInt(value)}`;
                        } else if (clientMessage?.text[0] === 'N/A') {
                            let res = clientMessage?.text[0];
                            let opr = logic.operator === '=' ? `==` : `${logic.operator}`;
                            let val = isNaN(value) ? `'${value}'` : value;

                            var expression = `'${res}'${opr}${val}`;
                            logicExpression = expression;

                            // logicExpression = `'${clientMessage?.text[0]}${
                            //     logic.operator === '='
                            //         ? `'=='`
                            //         : `'${logic.operator}'` /* > < >= <= 'Option 1 = Option 1' '5 < 5'*/
                            // }${value}'`;
                        } else {
                            logicExpression = 'false';
                        }
                    } else if (question.type === 'Checkbox List' || question.type === 'Radio List') {
                        logicExpression = `['${value.join("','")}'].includes(${response})`;
                    } else {
                        logicExpression = `${
                            response +
                            (logic.operator === '='
                                ? '=='
                                : logic.operator) /* > < >= <= 'Option 1 = Option 1' '5 < 5'*/
                        }'${value}'`;
                    }

                    try {
                        var match = eval(logicExpression);
                        cond += match;
                    } catch (ex) {
                        cond += 'false';
                    }
                } else {
                    cond += 'false';
                }
            });

        var placeholderCond = ApplyPlaceholderLogic(question, user);
        var dataSourceCondition = ApplyDataSourceLogic(question, user);
        return cond === ''
            ? `${placeholderCond && dataSourceCondition}`
            : `${cond} && ${placeholderCond} && ${dataSourceCondition}`;
    };

    const GetTranslation = (response, index, questionType, question_id) => {
        switch (questionType) {
            case 'Star Rating':
            case 'Rating':
                return [...response.map((x) => x.label)];
            case 'Radio List':
            case 'Checkbox List':
                var question = survey.questions.find((x) => x.id === question_id);
                if (question) {
                    var options = question.options[survey.defaultLanguageCode];
                    if (options && options.length > 0) {
                        const translation = response.map((x) => {
                            var option = options.find((y) => y.id === x.value);
                            return option.label;
                        });
                        return [...translation];
                    } else {
                        return [];
                    }
                } else {
                    return [];
                }
            case 'Comment List':
                return [];
        }
    };

    const GetProgress = (done, queue) => {
        let progress = 0;
        if (done.length === 0) {
            progress = 0;
        }

        var total = done.length + queue.length;

        if (total > 0) {
            if (done.find((x) => x.order === 999) || queue.find((x) => x.order === 999)) {
                total = total - 1;
            }
            progress = ((done.length - 1) / total) * 100;
        } else {
            progress = 0;
        }

        return { progress, total };
    };
    const GetRemainingTime = (done, queue) => {
        const questionTimes = new Map([
            ['Rating', 20],
            ['Comment List', 40],
            ['Checkbox List', 20],
            ['Radio List', 20],
            ['Star Rating', 20]
        ]);
        var totalRemainingTime = 0;
        if (done.length > 0) {
            totalRemainingTime += questionTimes.get(done[done?.length - 1]?.type); //getting the last question of done queue
        }
        queue?.map((question) => {
            totalRemainingTime += questionTimes.get(question?.type);
        });
        return totalRemainingTime;
    };

    return (
        <SurveyContext.Provider
            value={{
                question_queue,
                setQuestion_queue,
                question_done,
                setQuestion_done,
                question_pending,
                setQuestion_pending,
                convo,
                loading,
                setLoading,
                setConvo,
                InitSurvey,
                GetQuestionOptions,
                GetProgress,
                GetRemainingTime,
                setRemainingTime,
                remainingTime,
                timeFlag,
                setTimeflag,
                PopulateDoneQuestions,
                ApplyDisplayLogic,
                GetTranslation
            }}>
            {children}
        </SurveyContext.Provider>
    );
};

const useSurveyProvider = () => useContext(SurveyContext);

export default useSurveyProvider;
